<template>
    <div class="LibraryFilesHDLComponent DataTables">
        <p>{{ lang.infotext_1 }}:</p>
        <div class="list-details">
            <b-list-group>
                <b-list-group-item>
                    <div class="tree-container">
                    
                        <div class="tree">
                            <FoldersTreeHDLComponent :isPending="lastPendingRevision" :lastRevisionHistory="lastRevisionHistory"
                                :revisionId="revisionId" :lang="lang.FolderTreeItemHDL" isCategory="edit" ></FoldersTreeHDLComponent>
                        </div>
                        <!-- <LoaderComponent v-if="!isData"></LoaderComponent> -->

                    </div>
                </b-list-group-item>
        <!-- <div class="tree-empty"></div> -->
            </b-list-group>
        </div>

        
    </div>
</template>
<script>

import LoaderComponent from "@/components/shared/LoaderComponent";
import FoldersTreeHDLComponent from "@/components/shared/FoldersTreeHDLComponent"


export default {
    name: 'LibraryFilesHDLComponent',
    props: {
        lang: Object,
        parent: String
    },
    components: {
        LoaderComponent,
        FoldersTreeHDLComponent

    },
    data() {
        return {
            name: 'LibraryFilesHDLComponent',
            mainTable: "",
            id: "LibraryFilesHDLComponent" + this._uid,
            
            tree: [],
            isData: false

        }
    },
    computed: {
        revisionId() {
            if (this.$store.getters.selectedRows[0] != undefined) {
                return this.$store.getters.selectedRows[0].col___revisionId.revisionId;
            }
            return ""


        },
        isPlugin() {

            return this.$store.getters.isPlugin;



        },
        reloadedAfterActionComplex() {
            return this.$store.getters.reloadedAfterActionComplex;
        },
        lastPendingRevision() {
            let trig = false;
            
            return trig;
        },
        lastRevisionHistory() {

            let tab = this.$store.getters.revisionHistory;
            let obj = tab[0];
            for (let i = 0, lei = tab.length; i < lei; i++) {

                if (tab[i].revision > obj.revision) {
                    obj = tab[i];
                }
            }

            return obj;
        },
    },
    created() {

    },
    watch: {

    },
    updated() {

    },
    mounted: function () {

    },
    methods: {
               
        

    }
}
</script>


<style lang="scss">
.LibraryFilesHDLComponent {
    width: 100%;

    .dataTable {
        width: 100%;
    }

    table {
        font-size: 0.75rem;
        padding: 0px !important;

    }

    table th {
        padding: 2px !important;

    }

    table th select {
        width: 100% !important;

    }

    table td {
        padding: 0rem !important;

        padding-left: 0.2rem !important;
        padding-right: 0.2rem !important;

    }

    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    table.dataTable thead th p {
        margin-right: 20px;
    }

    .dataTables_processing {
        position: absolute;
        top: 20px;
        left: 50%;
        width: 100%;
        height: 20px;
        margin-left: -50%;
        margin-top: 50px;
        padding-top: 5px;
        text-align: center;
        font-size: 1em;

    }

    .dataTables_filter {
        font-size: 10px;
        float: left;
        width: 210px;
    }

    .searcher {
        float: left;
    }

    .dt-buttons {

        font-size: 0.7rem;
        margin-left: 210px;

    }

    .dataTables_filter .form-control-sm,
    .input-group-sm>.form-control {
        padding: 0.1rem 0.1rem;
        font-size: 0.7rem;
        line-height: 1;
        width: 200px;
    }

    .btn {
        padding-top: 1px;
        padding-bottom: 1px;
        padding-left: 3px;
        padding-right: 3px;

        font-size: 0.7rem;

    }

    .btn-group {
        display: block;
        padding-top: 2px;
    }

    ._dt-body-left {
        text-align: left;
    }

    ._dt-body-right {
        text-align: right;
    }

    ._dt-body-center {
        text-align: center;
    }

    .image {
        max-width: 40px;
        border: solid 3px #666;
        border-radius: 2px;
        margin-top: 3px;
        margin-bottom: 3px;
    }

    .imageSVG {
        max-width: 40px;
        border: solid 3px #666;
        border-radius: 2px;
        margin-top: 3px;
        margin-bottom: 3px;
        padding: 5px;
    }

    .button-action-download {
        margin: 2px;
        padding: 0px 3px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/LibraryFilesHDLComponent.vue